import { computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MinisitiResDto } from '@api/models';
import {
  patchState,
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { environment } from '../../../environments/environment';

export type OrganizzazioneState = {
  minisito: MinisitiResDto | null;
};

// Stato iniziale
const initialState: OrganizzazioneState = {
  minisito: null,
};

export const OrganizzazioneStore = signalStore(
  { providedIn: 'root' },
  withState<OrganizzazioneState>(initialState),
  withComputed((store) => ({
    logoSrc: computed(() => {
      const minisito = store.minisito();
      const raw = minisito?.organizzazione?.logoUrl; // es. s3://<prefisso>/<file.png>

      if (!raw) return 'assets/images/logo.png';

      if (raw.startsWith('s3://')) {
        const key = raw.substring('s3://'.length);
        const url = `${environment.apiUrl}/public/storage/logo?key=${encodeURIComponent(key)}`;
        return url;
      }
      return raw;
    }),
    indirizzoCompleto: computed(() => {
      const org = store.minisito()?.organizzazione;
      if (!org) return '';

      const linee: string[] = [];

      // Riga 1: indirizzo
      if (org.indirizzo?.trim()) {
        linee.push(org.indirizzo.trim());
      }

      // Riga 2: CAP + Comune (Provincia)
      const riga2Parts: string[] = [];
      if (org.cap?.toString().trim()) {
        riga2Parts.push(org.cap.toString().trim());
      }
      if (org.luogo?.comune?.trim()) {
        riga2Parts.push(org.luogo.comune.trim());
      }
      if (org.luogo?.siglaProvincia?.trim()) {
        riga2Parts.push(`(${org.luogo.siglaProvincia.trim()})`);
      }

      if (riga2Parts.length > 0) {
        linee.push(riga2Parts.join(' '));
      }

      return linee.join(', ');
    }),
  })),
  withMethods((store) => ({
    setMinisitoDetail(minisito: MinisitiResDto | null) {
      patchState(store, { minisito });
    },
  })),
  withHooks({
    onInit: (store, route = inject(ActivatedRoute)) => {},
  }),
);
